export enum ApplicationDrawerTabs {
  APPSUM = "AppSum",
  CONTACTHISTORY = "ContactHistory",
  FORMS = "Forms",
  WAITLIST = "WaitList",
  UNITCONSID = "UnitConsid",
  INTAKEANDOFFER = "IntakeAndOffer",
  TIMELINE = "Timeline",
  NEWANDPRS = "MoveToWaitlist",
  CANCELAPPLICATION = "CancelApplication",
  MOVEBACKTOREVIEW = "MoveBackToReview",
  OFFLINEAPPS = "OfflineApplications",
}
